import { useEffect, useState } from "react";
import Pagination from "components/Pagenation";
import { Link } from "react-router-dom";

const Orderlist = ({orderlist}) => {
    const today = new Date();
    const [orders, setOrders] = useState([]);

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const currentOrders = orders.slice(startIndex, endIndex);

    useEffect(() => {
        window.scrollTo({
            top: document.getElementById('admin-heading').offsetTop,
            behavior: 'smooth'
        });
    }, [currentPage]);

    const [select, setSelect] = useState("");

    const onChange = (e) => {
        setCurrentPage(1);
        setSelect(e.target.value);
    }

    useEffect(() => {
        const storedValue = localStorage.getItem('selectedValue');
        const storedPage = localStorage.getItem('currentPage');

        if (storedValue) {
            setSelect(storedValue);
        } else {
            setSelect('전체주문'); // 기본 값 설정
        }

        if(storedPage) {
            setCurrentPage(storedPage);
        } else {
            setCurrentPage(1);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('selectedValue', select);
        localStorage.setItem('currentPage', currentPage);
        
        if (select === '전체주문') {
            setOrders(orderlist.sort((a, b) => b.createdTime - a.createdTime));
        } else if (select === '예약중') {
            setOrders(
                orderlist
                .filter((order) => new Date(order.reservDate).getTime() > today.getTime())
                .sort((a, b) => new Date(a.reservDate).getTime() - new Date(b.reservDate).getTime())
            );
        } else if (select === '대여중') {
            setOrders(
                orderlist
                .filter(
                    (order) =>
                    new Date(order.reservDate).getTime() <= today.getTime() && new Date(order.returnDate).getTime() > today.getTime()
                )
                .sort((a, b) => new Date(a.returnDate).getTime() - new Date(b.returnDate).getTime())
            );
        } else if (select === '반납완료') {
            setOrders(
                orderlist
                .filter((order) => new Date(order.returnDate).getTime() < today.getTime())
                .sort((a, b) => new Date(b.returnDate).getTime() - new Date(a.returnDate).getTime())
            );
        }
    }, [select, orderlist, currentPage]);

    // 브라우저를 닫거나 페이지를 이탈할 때 localStorage 에 값을 저장합니다.
    window.onbeforeunload = () => {
        localStorage.setItem('selectedValue', select);
        localStorage.setItem('currentPage', currentPage);
    };

    return (
        <section className="page-section bg-light" id="orderlist">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase" id="admin-heading">Admin</h2>
                </div>
                <div className="row text-center">
                    <h2>주문내역
                        <br />
                        <select className="listSelect" id="orderListSelect" onChange={onChange}>
                            <option value="전체주문">전체주문_최신순({orderlist ? `${orderlist.length}건` : null})</option>
                            <option value="예약중">예약 중({orders ? `${orderlist.filter(order => new Date(order.reservDate).getTime() > today.getTime()).length}건` : null})</option>
                            <option value="대여중">대여 중({orders ? `${orderlist.filter(order => new Date(order.reservDate).getTime() <= today.getTime() && new Date(order.returnDate).getTime() > today.getTime()).length}건` : null})</option>
                            <option value="반납완료">반납 완료({orders ? `${orderlist.filter(order => new Date(order.returnDate).getTime() < today.getTime()).length}건` : null})</option>
                        </select>
                    </h2>
                </div>
            </div>
                {orderlist && orderlist.length > 0 ?
                    currentOrders.map((item, index) => 
                    <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}} key={item.id}>
                        <Link to={process.env.PUBLIC_URL + `/account/confirm/${item.id}`} style={{color: "black"}}>
                            <div className="row mb-3"  id="orderContent">
                                <div className="col-6">
                                    <div className="text-info">
                                        <i className="fas fa-plane"></i>
                                        &nbsp; {item.destination ? `${item.destination}` : `${item.nation}_${item.city}`}
                                    </div>
                                </div>
                                <div className="col-6 text-end">
                                    {item.reservDate}~{item.returnDate}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6 text-dark">
                                    <h5>&nbsp;#{startIndex+(index+1)}. {item.name}</h5>
                                </div>
                                <div className="col-6 text-end">
                                    <h5 className={item.payment ? "paymentTrue" : "paymentFalse"}>{item.payment ? "입금완료":"입금 전"}</h5>
                                    {item.cnumber}번/{item.size}인치
                                </div>
                            </div>
                        </Link>
                    </div>
                )                                
                :
                (
                    <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}}>
                        <div className="row mb-3">
                            <h5>주문 내역이 없습니다...</h5>
                        </div>
                    </div>
                )
            }
            <div className="pagination-container">
            <Pagination
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                totalItems={orders.length}
                onPageChange={setCurrentPage}
            />
            </div>
        </section>
    )
}

export default Orderlist;